// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-privacy[data-v-66db10be]{width:100%;min-height:100vh;background:#fff}.container-privacy .main[data-v-66db10be]{padding:0 16px 16px 16px;color:#666;line-height:20px}", ""]);
// Exports
module.exports = exports;
